

import { useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Logo from '../assets/navbar.png'
function AppNavbar() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // ⭐ menu open/close track karne ke liye

  const linkStyle = {
    position: "relative",
    margin: "0 12px",
    color: "#000",
    fontWeight: 750,
    textDecoration: "none",
    transition: "color 0.3s ease-in-out",
    padding: "10px 0",
    lineHeight: "1.2",
    display: "inline-block",
  };

  const activeLink = {
    color: "#0dcaf0",
    fontWeight: 600,
  };

  const hoverEffect = (e) => {
    e.target.style.color = "#0dcaf0";
  };

  const removeHover = (e, path) => {
    if (location.pathname !== path) {
      e.target.style.color = "#000";
    }
  };

  // ⭐ Kisi bhi link/option par click hone par menu band ho jayega
  const closeMenu = () => setExpanded(false);

  return (
    <>
      {/* 🟦 Custom underline animation + mobile responsive fix styles */}
      <style>
        {`
          .nav-link-underline {
            position: relative;
            display: inline-block;
          }
          .nav-link-underline::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0%;
            height: 2px;
            background-color: #0dcaf0;
            transition: width 0.4s ease;
          }
          .nav-link-underline:hover::after {
            width: 100%;
          }
          .nav-link-underline.active::after {
            width: 100%;
          }

          /* ⭐ Desktop pe logo thoda left shift */
          .app-navbar .navbar-brand {
            margin-left: -30px;
          }

          /* ⭐ MOBILE RESPONSIVE FIX (lg se neeche, jab menu collapse hoke hamburger banta hai) */
          @media (max-width: 991.98px) {
            /* Logo left se cut ho raha tha, ab thoda right shift + cut na ho iske liye */
            .app-navbar .navbar-brand {
              margin-left: 8px !important;
              max-width: 75%;
            }

            .app-navbar .navbar-brand img {
              height: 42px !important;
              max-width: 100%;
            }

            /* Collapse menu ko solid white background + shadow + proper spacing */
            .app-navbar .navbar-collapse {
              background-color: #ffffff;
              margin-top: 12px;
              padding: 16px;
              border-radius: 10px;
              box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
            }

            /* Har link full width, apni line pe, aur left align */
            .app-navbar .navbar-nav {
              width: 100%;
            }

            .app-navbar .nav-link-underline,
            .app-navbar .dropdown {
              display: block !important;
              width: 100%;
              margin: 0 !important;
              padding: 10px 4px !important;
              border-bottom: 1px solid #f0f0f0;
            }

            .app-navbar .dropdown-toggle {
              width: 100%;
            }

            .app-navbar .dropdown-menu {
              width: 100%;
              box-shadow: none;
              border: none;
              padding-left: 12px;
            }

            /* Sign Up button ko thoda space aur full width look */
            .app-navbar .signup-btn {
              margin: 12px 0 0 0 !important;
              width: 100%;
              text-align: center;
              padding: 10px 0 !important;
            }

            /* Hamburger icon clearly visible rahe, mobile pe size thoda chhota */
            .app-navbar .navbar-toggler {
              border: 1px solid rgba(0,0,0,0.2);
              padding: 4px 8px;
              font-size: 0.9rem;
            }

            .app-navbar .navbar-toggler-icon {
              width: 1.2em;
              height: 1.2em;
            }
          }
        `}
      </style>

      <Navbar
        bg="light"
        expand="lg"
        className="shadow-sm sticky-top app-navbar"
        expanded={expanded}
        onToggle={(val) => setExpanded(val)}
        style={{
          fontFamily: "Poppins, sans-serif",
          padding: "15px 0",
        }}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" onClick={closeMenu}>
            <img
              src={Logo}
              alt="STOCK MARKET INVESTING BY GROW CAPITAL Logo"
              height="60"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {/* ✅ Main links */}
              {[
                { name: "Home", path: "/" },
                { name: "About", path: "/about" },
              ].map((link) => (
                <Nav.Link
                  key={link.path}
                  as={Link}
                  to={link.path}
                  className={`nav-link-underline ${
                    location.pathname === link.path ? "active" : ""
                  }`}
                  style={
                    location.pathname === link.path
                      ? { ...linkStyle, ...activeLink }
                      : linkStyle
                  }
                  onMouseEnter={hoverEffect}
                  onMouseLeave={(e) => removeHover(e, link.path)}
                  onClick={closeMenu}
                >
                  {link.name}
                </Nav.Link>
              ))}

              {/* ✅ Services Dropdown */}
              <NavDropdown
                title="Services"
                id="services-dropdown"
                style={linkStyle}
                menuVariant="light"
              >
                <NavDropdown.Item as={Link} to="/services" onClick={closeMenu}>
                  Service
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/mutual-fund" onClick={closeMenu}>
                  Mutual Fund
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/insurance" onClick={closeMenu}>
                  Insurance
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services" onClick={closeMenu}>
                  IPO
                </NavDropdown.Item>
              </NavDropdown>

              {/* ✅ Other links */}
              {[
                { name: "Account", path: "/account" },
                { name: "Pricing", path: "/pricing" },
                { name: "Login", path: "/login" },
              ].map((link) => (
                <Nav.Link
                  key={link.path}
                  as={Link}
                  to={link.path}
                  className={`nav-link-underline ${
                    location.pathname === link.path ? "active" : ""
                  }`}
                  style={
                    location.pathname === link.path
                      ? { ...linkStyle, ...activeLink }
                      : linkStyle
                  }
                  onMouseEnter={hoverEffect}
                  onMouseLeave={(e) => removeHover(e, link.path)}
                  onClick={closeMenu}
                >
                  {link.name}
                </Nav.Link>
              ))}

              {/* ✅ Sign Up Button */}
              <Nav.Link
                as={Link}
                to="/signup"
                className="btn btn-primary px-3 ms-2 rounded-pill shadow-sm signup-btn"
                style={{ fontWeight: 600 }}
                onClick={closeMenu}
              >
                Sign Up
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AppNavbar;